import { Radio } from "@mui/material";
import React from "react";
import { ScheduleConsultType, UpdateStatus } from "../../core/http/service/SchedulingService";
import { H1, Span } from "../UI/generalLayout/Layout.styled";
import {
  CollaboratorInitialSchedulingModalRadioContainer,
  CollaboratorInitialSchedulingModalRadioHeader,
} from "./CollaboratorInitialSchedulingModal.styled";

// import { Container } from './styles';

export interface CollaboratorInitialSchedulingModalRadioProps {
  value: ScheduleConsultType | UpdateStatus;
  selectedRadio?: ScheduleConsultType | UpdateStatus;
  onChange: (value: ScheduleConsultType | UpdateStatus) => void;
  title: string;
  subText?: any;
  fontSize?: string;
  width?: number;
}

const CollaboratorInitialSchedulingModalRadio: React.FC<
  CollaboratorInitialSchedulingModalRadioProps
> = ({ onChange, selectedRadio, value, title, subText, fontSize, width }) => {
  return (
    <CollaboratorInitialSchedulingModalRadioContainer width={width}>
      <CollaboratorInitialSchedulingModalRadioHeader>
        <Radio
          checked={selectedRadio === value}
          onChange={() => onChange(value)}
        />
        <H1 style={{color: "#0A5190", fontSize: 17}}>{title}</H1>
      </CollaboratorInitialSchedulingModalRadioHeader>
      <Span textAlign="left">{subText}</Span>
    </CollaboratorInitialSchedulingModalRadioContainer>
  );
};

export default CollaboratorInitialSchedulingModalRadio;
